import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from '../AllProducts/AllProducts'
import Button from '../../components/Button'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import { cashbackApi } from '../../api'
import { get } from 'lodash'
import { isAxiosError } from 'axios'
import moment from 'moment'
import dayjs from 'dayjs'
import { DatePicker, Empty, Tag } from 'antd'
import { BG_COLOR } from '../../constants/colors'

const { RangePicker } = DatePicker
const dateFormat = 'YYYY-MM-DD'

const typeLabels = {
	EARN: 'Начисление',
	REDEEM: 'Списание',
}

const statusColors = {
	USED: 'green',
	ACTIVE: 'blue',
	EXPIRED: 'red',
	CANCELLED: 'default',
}

const postingStatusColors = {
	POSTED: 'blue',
	RECONCILED: 'green',
	CANCELLED: 'default',
	FAILED: 'red',
}

const Ledger = () => {
	const errorRef = useRef()

	const [isLoading, setIsLoading] = useState(false)
	const [items, setItems] = useState([])
	const [phone, setPhone] = useState('')
	const [page, setPage] = useState(1)
	const [pageSize, setPageSize] = useState(50)
	const [totalCount, setTotalCount] = useState(0)
	const [totalPages, setTotalPages] = useState(1)
	const [dateStart, setDateStart] = useState(
		moment().startOf('month').format(dateFormat),
	)
	const [dateEnd, setDateEnd] = useState(moment().format(dateFormat))
	const [expandedIds, setExpandedIds] = useState(new Set())

	const toggleExpand = (id) => {
		setExpandedIds((prev) => {
			const next = new Set(prev)
			if (next.has(id)) next.delete(id)
			else next.add(id)
			return next
		})
	}

	const onRangeChange = (dates) => {
		if (dates) {
			setDateStart(dates[0].format(dateFormat))
			setDateEnd(dates[1].format(dateFormat))
		} else {
			setDateStart('')
			setDateEnd('')
		}
	}

	const getLedger = () => {
		setIsLoading(true)
		cashbackApi
			.get('ledger', {
				params: {
					phone: phone || undefined,
					from: dateStart
						? moment(dateStart).startOf('day').toISOString()
						: undefined,
					to: dateEnd ? moment(dateEnd).endOf('day').toISOString() : undefined,
					page,
					pageSize,
				},
			})
			.then((res) => {
				setItems(get(res, 'data.items', []))
				setTotalCount(get(res, 'data.totalCount', 0))
				setTotalPages(get(res, 'data.totalPages', 1))
			})
			.catch((err) => {
				if (isAxiosError(err))
					errorRef.current?.open(
						get(err, 'response.data.message', get(err, 'message', '')),
					)
			})
			.finally(() => setIsLoading(false))
	}

	useEffect(() => {
		getLedger()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, pageSize])

	const handleSearch = () => {
		if (page === 1) getLedger()
		else setPage(1)
	}

	return (
		<Layout>
			<AllProductsStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle">Кэшбэк история</p>

					<div className="flex items-end justify-between my-8 flex-wrap gap-4">
						<div className="flex items-end gap-4 flex-wrap">
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Телефон</p>
								<input
									className={
										'border-[1px] border-[#d9d9d9] p-2 rounded-md h-10 w-[180px]'
									}
									type="text"
									placeholder="Телефон"
									value={phone}
									onChange={(e) => setPhone(e.target.value)}
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Период</p>
								<RangePicker
									value={[
										dateStart ? dayjs(dateStart, dateFormat) : null,
										dateEnd ? dayjs(dateEnd, dateFormat) : null,
									]}
									format={dateFormat}
									onChange={onRangeChange}
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">На странице</p>
								<select
									className="border-[1px] border-[#d9d9d9] p-2 h-10 rounded-md"
									value={pageSize}
									onChange={(e) => {
										setPageSize(Number(e.target.value))
										setPage(1)
									}}
								>
									<option value={10}>10</option>
									<option value={20}>20</option>
									<option value={50}>50</option>
									<option value={100}>100</option>
								</select>
							</div>
							<Button
								className="!h-10"
								onClick={handleSearch}
								isLoading={isLoading}
							>
								Поиск
							</Button>
						</div>
						<p className="text-sm text-gray-500">Всего: {totalCount}</p>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-x-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-2 py-4 w-8"></th>
											<th scope="col" className="px-6 py-4">
												Дата
											</th>
											<th scope="col" className="px-6 py-4">
												Карта
											</th>
											<th scope="col" className="px-6 py-4">
												Имя
											</th>
											<th scope="col" className="px-6 py-4">
												Телефон
											</th>
											<th scope="col" className="px-6 py-4">
												Продажа
											</th>
											<th scope="col" className="px-6 py-4">
												Тип
											</th>
											<th scope="col" className="px-6 py-4">
												Статус
											</th>
											<th scope="col" className="px-6 py-4">
												Сумма
											</th>
											<th scope="col" className="px-6 py-4">
												Дата использования
											</th>
											<th scope="col" className="px-6 py-4">
												Проводка
											</th>
											<th scope="col" className="px-6 py-4">
												Комментарий
											</th>
										</tr>
									</thead>
									<tbody>
										{items.length > 0 ? (
											items.map((v) => {
												const postings = get(v, 'postings', [])
												const isExpanded = expandedIds.has(get(v, 'id'))
												return (
													<React.Fragment key={get(v, 'id')}>
														<tr className="bg-white border-b  hover:bg-gray-50 ">
															<td className="px-2 py-4 text-center">
																{postings.length > 0 && (
																	<button
																		type="button"
																		onClick={() => toggleExpand(get(v, 'id'))}
																		className="text-gray-500 hover:text-gray-800"
																	>
																		{isExpanded ? '▾' : '▸'}
																	</button>
																)}
															</td>
															<td className="px-6 py-4">
																{moment(get(v, 'createdAt')).format(
																	'DD-MM-YYYY HH:mm',
																)}
															</td>
															<td className="px-6 py-4">
																{get(v, 'cardCode', '-')}
															</td>
															<td className="px-6 py-4">
																{get(v, 'cardName', '-')}
															</td>
															<td className="px-6 py-4">
																{get(v, 'phone', '-')}
															</td>
															<td className="px-6 py-4">
																{get(v, 'saleId', '-')}
															</td>
															<td className="px-6 py-4">
																{typeLabels[get(v, 'type')] ||
																	get(v, 'type', '-')}
															</td>
															<td className="px-6 py-4">
																<Tag color={statusColors[get(v, 'status')]}>
																	{get(v, 'status', '-')}
																</Tag>
															</td>
															<td className="px-6 py-4">
																{get(v, 'amount', '-')} {get(v, 'currency', '')}
															</td>
															<td className="px-6 py-4">
																{get(v, 'usedAt')
																	? moment(get(v, 'usedAt')).format(
																			'DD-MM-YYYY HH:mm',
																		)
																	: '-'}
															</td>
															<td className="px-6 py-4">
																{get(v, 'journalEntryNumber', '-')}
															</td>
															<td className="px-6 py-4">
																{get(v, 'notes', '-') || '-'}
															</td>
														</tr>
														{isExpanded && postings.length > 0 && (
															<tr className="bg-gray-50 border-b">
																<td></td>
																<td colSpan="10" className="px-6 py-3">
																	<table className="w-full text-xs text-left text-gray-600 border border-gray-200 rounded-md overflow-hidden">
																		<thead className="text-[11px] text-gray-600 uppercase bg-gray-100">
																			<tr>
																				<th className="px-4 py-2">База</th>
																				<th className="px-4 py-2">Карта</th>
																				<th className="px-4 py-2">Проводка</th>
																				<th className="px-4 py-2">Статус</th>
																				<th className="px-4 py-2">
																					Сторно проводка
																				</th>
																				<th className="px-4 py-2">Создано</th>
																				<th className="px-4 py-2">Закрыто</th>
																				<th className="px-4 py-2">
																					Комментарий
																				</th>
																			</tr>
																		</thead>
																		<tbody>
																			{postings.map((p, idx) => (
																				<tr
																					key={`${get(v, 'id')}-${idx}`}
																					className="bg-white border-b last:border-b-0"
																				>
																					<td className="px-4 py-2">
																						{get(p, 'companyDb', '-')}
																					</td>
																					<td className="px-4 py-2">
																						{get(p, 'cardCode', '-')}
																					</td>
																					<td className="px-4 py-2">
																						{get(p, 'journalEntryNumber', '-')}
																					</td>
																					<td className="px-4 py-2">
																						<Tag
																							color={
																								postingStatusColors[
																									get(p, 'status')
																								]
																							}
																						>
																							{get(p, 'status', '-')}
																						</Tag>
																					</td>
																					<td className="px-4 py-2">
																						{get(
																							p,
																							'cancelJournalEntryNumber',
																							'-',
																						) || '-'}
																					</td>
																					<td className="px-4 py-2">
																						{get(p, 'createdAt')
																							? moment(
																									get(p, 'createdAt'),
																								).format('DD-MM-YYYY HH:mm')
																							: '-'}
																					</td>
																					<td className="px-4 py-2">
																						{get(p, 'closedAt')
																							? moment(
																									get(p, 'closedAt'),
																								).format('DD-MM-YYYY HH:mm')
																							: '-'}
																					</td>
																					<td className="px-4 py-2">
																						{get(p, 'notes', '-') || '-'}
																					</td>
																				</tr>
																			))}
																		</tbody>
																	</table>
																</td>
															</tr>
														)}
													</React.Fragment>
												)
											})
										) : (
											<tr>
												<td colSpan="12">
													<Empty
														description={'Ничего не найдено'}
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2">
									<Button
										disabled={page <= 1}
										className={'btn'}
										onClick={() => setPage((p) => p - 1)}
									>
										{'<'}
									</Button>
									<p>
										{page} / {totalPages || 1}
									</p>
									<Button
										disabled={page >= totalPages}
										className={'btn'}
										onClick={() => setPage((p) => p + 1)}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
		</Layout>
	)
}

export default Ledger
